module.exports = __webpack_public_path__ + "static/img/2.eea0ef5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/honor/2.png
// module id = 57PL
// module chunks = 1